import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { GlobalEnvironment, getParams } from 'Helpers';
import { SnaiV } from 'Models';
import { msalTemp } from 'Contexts/AuthProvider';

export class SnaiVService {

    static GetSnaiV(): Observable<SnaiV[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/SnaiV`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static GetSnaiVByProjectId(projectId: number): Observable<SnaiV[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/SnaiV/${projectId}`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}